import { createFileRoute } from '@tanstack/react-router'

import { VoicesPage } from '#/modules/voices'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/voices')({
  component: VoicesPage,
  validateSearch: validateListSearch,
})
